const URLs = {
  CONTINUE_TRANSACTION: "/ibt-external/transaction/continue/new",
  CONTINUE_VERIFICATION: "/ibt-external/transaction/continue/verification",
  GET_TRANSACTION_STATUS: "/transaction/v4/interactive/status",
  GET_RFP_STATUS: "/transaction/v4/interactive/status",
};

export default URLs;
